import { useMemo } from 'react';

import AnalyticsResponseData from 'components/insights/query/AnalyticsResponseData';
import DataTable from 'components/shared/DataTable';

import { buildInboundColumns, buildInboundRows } from './inboundReferralDetailsColumns';

type Props = {
  loading: boolean;
  data: AnalyticsResponseData;
  entityHeader: string;
};

const DEFAULT_SORT = [{ id: 'referrals', desc: true }];

export default function InboundReferralDetailsTable({ loading, data, entityHeader }: Props) {
  const rows = useMemo(() => buildInboundRows(data), [data]);
  const columns = useMemo(() => buildInboundColumns(entityHeader), [entityHeader]);

  return (
    <DataTable
      columns={columns}
      data={rows}
      defaultSortBy={DEFAULT_SORT}
      loading={loading}
      hasFooter={false}
      maxHeight='520px'
      freezeFirstColumn
    />
  );
}
